module.exports = __webpack_public_path__ + "assets/img/app-store.93b8fc35.png";